/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CheckIcon from 'vux/src/components/check-icon';
import Datetime from 'vux/src/components/datetime';
import XTextarea from 'vux/src/components/x-textarea';
import XButton from 'vux/src/components/x-button';
import UploadImageRequired from '@/components/UploadImage/UploadImageRequired';
import atitle from '@/components/Approve/atitle';
import { Dialog, Toast } from 'vant'; // -----审批节点

import FixedNode from '@/components/Approve/FixedNode';
import AssignNode from '@/components/Approve/AssignNode';
import OfficersNode from '@/components/Approve/OfficersNode';
import NoAssiginNode from '@/components/Approve/NoAssiginNode';
import copyOffNode from '@/components/Approve/copyOffNode';
import copyNoAssiginNode from '@/components/Approve/copyNoAssiginNode';
import copyFixedNode from '@/components/Approve/copyFixedNode';
export default {
  name: 'RepairAttendance',
  components: {
    Datetime: Datetime,
    XTextarea: XTextarea,
    XButton: XButton,
    CheckIcon: CheckIcon,
    UploadImageRequired: UploadImageRequired,
    atitle: atitle,
    FixedNode: FixedNode,
    AssignNode: AssignNode,
    OfficersNode: OfficersNode,
    NoAssiginNode: NoAssiginNode,
    copyOffNode: copyOffNode,
    copyNoAssiginNode: copyNoAssiginNode,
    copyFixedNode: copyFixedNode
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$utils.Store.removeItem('onTime');
    this.$utils.Store.removeItem('offTime');
    this.$utils.Store.removeItem('repairDate');
    this.$utils.Store.removeItem('reason');
    next();
  },
  data: function data() {
    return {
      type: '2',
      typeShow: false,
      actions: this.$api.Base.dev + '/management/insertPhoto',
      bh: '00203',
      repairDate: this.$utils.Store.getItem('repairDate') ? this.$utils.Store.getItem('repairDate') : '',
      //补出勤日期
      startDate: '',
      //今天日期
      onTime: this.$utils.Store.getItem('onTime') ? this.$utils.Store.getItem('onTime') : '',
      //上班时间
      offTime: this.$utils.Store.getItem('offTime') ? this.$utils.Store.getItem('offTime') : '',
      //下班时间
      onValue: this.$utils.Store.getItem('onTime') ? true : false,
      //上班补录设置
      offValue: this.$utils.Store.getItem('offTime') ? true : false,
      //下班补录设置
      reason: this.$utils.Store.getItem('reason') ? this.$utils.Store.getItem('reason') : '',
      //补录事由
      inputParam: [{
        name: 'att_id',
        value: 0
      }, {
        name: 'base64String',
        value: ''
      }, {
        name: 'typeId',
        value: -1
      }],
      imgList: [],
      //图片列表数组
      limitNum: 5,
      //最多上传图片张数
      approverString: '',
      //审批人序号--字符串
      customerString: '',
      //抄送人序号--字符串
      depSerial: this.$utils.Store.getItem('orgId'),
      //企业ID
      depName: this.$utils.Store.getItem('orgName'),
      //企业名称
      imgPath: [],
      //图片地址
      imgIndex: 0,
      //图片数组下标
      choose: this.$utils.Store.getItem('choose') ? this.$utils.Store.getItem('choose') : 0,
      //添加人员类型   1：审批人  2：抄送人  3：同行人
      //  ----以下是lwt的变量--2020-07-01
      approve: [],
      //要提交的审批节点列表
      allUserList: [],
      //获取过来的审批节点
      process: 0,
      //0简单审批 1条件审批
      userSerial: this.$utils.Store.getItem('userSerial'),
      //人员编号
      approveConditionId: '',
      approveSettingId: '',
      cc: {},
      //抄送人
      haveCC: false,
      //有没有抄送人
      showLevel: '',
      sbmitDis: true,
      //是否可以点击
      approveStatues: false,
      //控制提交状态isDisabled
      chaosongzhuangtai: false //控制提交状态isDisabled

    };
  },
  computed: {
    isDisabled: function isDisabled() {
      var flag = false;

      if (this.sbmitDis && this.repairDate !== '' && this.reason !== '' && (this.onTime !== '' || this.offTime !== '')) {
        /**/
      } else {
        flag = true;
      }

      return flag;
    },
    checkOn: function checkOn() {
      if (this.onValue == true) {
        return false;
      } else {
        return true;
      }
    },
    checkOff: function checkOff() {
      if (this.offValue == true) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    getShenpiRenshu: function getShenpiRenshu(aa) {
      /* 审批人数关联提交状态子组建传值 */
      if (aa > 0) {
        this.approveStatues = true;
      } else if (aa == 0) {
        this.approveStatues = false;
      }
    },
    gechaosongrenshu: function gechaosongrenshu(aa) {
      /*抄送人数关联提交状态子组建传值 */
      if (aa > 0) {
        this.chaosongzhuangtai = true;
      } else if (aa == 0) {
        this.chaosongzhuangtai = false;
      }
    },
    getSetting: function getSetting() {
      var _this = this;

      this.$api.Sys.getSystemParams(0, this.$constant.repairAttendanceType).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);
        } else {
          if (data === null) {
            _this.type = '2';
          } else {
            _this.type = data.paramValue;

            if (_this.type === '0') {
              _this.onValue = true;
            }

            if (_this.type === '1') {
              _this.offValue = true;
            }

            _this.$utils.Store.setLocalItem('repairAttendanceType', data.paramValue);
          }
        }

        _this.typeShow = true;
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },

    /** function 获取服务器时间---今日日期
     *   wzx
     *   2019-01-11
     **/
    getSysDate: function getSysDate() {
      var _this2 = this;

      this.$utils.Tools.loadShow();
      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        _this2.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          _this2.startDate = data.sysDate.substring(0, 10);
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },

    /** function 获取补出勤日期
     *   wzx
     *   2019-01-11
     **/
    changeRepairDate: function changeRepairDate(val) {
      this.repairDate = val;
      this.$utils.Store.setItem('repairDate', val);
    },

    /** function 获取上班时间
     *   wzx
     *   2019-01-11
     **/
    changeOnTime: function changeOnTime(val) {
      var _this3 = this;

      this.onTime = val;
      this.$utils.Store.setItem('onTime', val);

      if (this.offTime != '' && this.onTime > this.offTime) {
        Toast('上班时间不能大于下班时间');
        setTimeout(function () {
          _this3.onTime = '';
        }, 2000);
      }
    },

    /** function 获取下班时间
     *   wzx
     *   2019-01-11
     **/
    changeOffTime: function changeOffTime(val) {
      var _this4 = this;

      this.offTime = val;
      this.$utils.Store.setItem('offTime', val);

      if (this.onTime != '' && this.offTime < this.onTime) {
        Toast('下班时间不能小于上班时间');
        setTimeout(function () {
          _this4.offTime = '';
        }, 2000);
      }
    },

    /** function 获取补打卡事由
     *   wzx
     *   2019-01-07
     **/
    getReason: function getReason(val) {
      this.reason = val;
      this.$utils.Store.setItem('reason', val);
    },
    // ----判断什么方式获取审批节点
    changeget: function changeget() {
      var _this5 = this;

      this.allUserList = [];
      this.leaveList.some(function (item) {
        if (_this5.bh == item.value && item.process == 0) {
          _this5.getNodeList();

          return true;
        } else if (_this5.bh == item.value && item.process == 1) {
          if (_this5.startDate && _this5.endDate) {
            _this5.getNodeList();

            return true;
          }
        }
      });
    },

    /** function 遍历数组是否少
     *   wzx
     *  202-0706
     **/
    ergArray: function ergArray(list) {
      if (!list) {
        return true;
      }

      var uindex = list.findIndex(function (item) {
        return !item.userSerial[0];
      });
      return uindex != -1;
    },

    /** function 提交出差申请
     *   wzx
     *   2019-01-05
     * */

    /** function 提交出差申请
     *   wzx
     *   2019-01-05
     * */
    submitClick: function submitClick() {
      var _this6 = this;

      if (this.ergArray(this.approve)) {
        Toast('未选择审批人');
        return;
      } else if (this.haveCC && !this.cc.userSerial[0]) {
        Toast('未选择抄送人');
        return;
      }

      this.imgPath = [];
      this.sbmitDis = false;

      var _iterator = _createForOfIteratorHelper(this.imgList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var imgs = _step.value;
          this.imgPath.push(imgs.serverId);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var imgPath = JSON.stringify(this.imgPath).replace(/\[|]|"/g, '');
      this.$utils.Tools.loadShow();
      var businessEntity = {
        bh: '00203',
        bz: this.reason,
        imgPath: imgPath,
        sbsj: this.$utils.Store.getItem('onTime') ? this.repairDate + ' ' + this.onTime : '',
        xbsj: this.$utils.Store.getItem('offTime') ? this.repairDate + ' ' + this.offTime : '',
        processId: '',
        qjlx: 1,
        userSerial: this.$utils.Store.getItem('userSerial')
      };
      var params = {
        businessEntity: businessEntity,
        approveCode: 5,
        approveSettingId: this.approveSettingId,
        approveConditionId: this.approveConditionId,
        approveCodeSub: '00203',
        petitioner: this.$utils.Store.getItem('userSerial'),
        cc: [this.cc],
        showLevel: this.showLevel,
        approve: this.approve
      };
      this.$api.Appr.apply(params).then(function (response) {
        _this6.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;
        _this6.sbmitDis = true;

        if (code == '625' || code == '626') {
          _this6.$utils.Tools.loadHide();

          Dialog.alert({
            title: '提示',
            message: msg,
            messageAlign: 'left',
            width: '70%',
            closeOnPopstate: true
          }).then(function () {
            // on close
            _this6.$router.go(0);
          });
          return;
        }

        if (+code === _this6.$code.success) {
          Toast('提交成功');

          _this6.$router.go(-1);
        }
      }).catch(function () {
        _this6.$utils.Tools.httpError();
      });
    },

    /** function 当前提交审批节点中是否有对应的节点
     *   lwt
     *   2020-07-03
     * */
    inspectObj: function inspectObj(sub) {
      var index = 0;
      var flag = this.approve.some(function (items, i) {
        if (items.level == sub.level) {
          index = i;
          return true;
        }
      });
      return {
        index: index,
        flag: flag
      };
    },

    /** function 获取子集的节点对象
     *   lwt
     *   2020-07-03
     * */
    getSubUserObj: function getSubUserObj(appr) {
      if (appr.cc && appr.cc == 1) {
        this.cc = appr;
        return;
      }

      if (this.approve.length == 0) {
        this.approve.push(appr);
      } else {
        var insUser = this.inspectObj(appr);

        if (insUser.flag) {
          //如果有重复的
          this.approve[insUser.index] = appr;
        } else {
          //没有重复的
          this.approve.push(appr);
        }
      }
    },

    /** function 获取可审批的节点
     *   lwt
     *   2020-07-04
     * */
    getNodeList: function getNodeList() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.$utils.Tools.loadShow();

                _this7.allUserList = [];
                _this7.cc = {};
                _this7.haveCC = false;
                params = {
                  approveCode: '5',
                  //请假
                  subCode: _this7.bh,
                  startTime: _this7.kssj,
                  //开始时间
                  endTime: _this7.jssj,
                  //结束时间
                  userSerial: _this7.userSerial //人员序列

                };
                _context.next = 7;
                return _this7.$api.Appr.getApplicants(params).then(function (response) {
                  var code = response.code,
                      msg = response.msg,
                      data = response.data;

                  if (code == '602') {
                    _this7.$utils.Tools.loadHide();

                    Dialog({
                      title: '提示',
                      message: msg,
                      messageAlign: 'left',
                      width: '70%',
                      closeOnPopstate: true
                    });
                    return;
                  }

                  if (+code !== _this7.$code.success) {
                    _this7.$utils.Tools.loadHide();

                    Toast(msg);
                  } else {
                    _this7.$utils.Tools.loadHide();

                    _this7.showLevel = data.showLevel;

                    if (data.showLevel == '1') {
                      _this7.allUserList = data.approve;
                    } else {
                      for (var i = 0; i < data.approve.length; i++) {
                        if (data.approve[i].level < data.showLevel) {
                          (function () {
                            var userItem = {};
                            var user = [];
                            data.approve[i].user.some(function (sub) {
                              user.push(sub.userSerial);
                            });
                            userItem.level = data.approve[i].level;
                            userItem.way = data.approve[i].levelWay;
                            userItem.levelId = data.approve[i].levelId;
                            userItem.userSerial = user;

                            _this7.approve.push(userItem);
                          })();
                        } else {
                          _this7.allUserList.push(data.approve[i]);
                        }
                      }
                    }

                    if (data.ccSet) {
                      _this7.haveCC = true;
                      _this7.allUserList[_this7.allUserList.length] = data.ccSet; //抄送
                    }

                    _this7.approveConditionId = data.approveConditionId;
                    _this7.approveSettingId = data.approveSettingId;
                    _this7.process = data.process;
                  }
                }).catch(function () {
                  _this7.$utils.Tools.httpError();
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  watch: {
    itemUser: {
      deep: true,
      // 深度监听
      immediate: true,
      // 监听到后，立即执行 handler方法
      handler: function handler() {}
    }
  },
  created: function created() {
    this.getSysDate();
    this.getNodeList();
    this.getSetting();
  },
  mounted: function mounted() {// this.pushHistory();
    // window.onpopstate = () => {
    //     this.$router.push('/Application')  //输入要返回的上一级路由地址
    // }
  }
};